module.exports = __webpack_public_path__ + "img/material-yellow-800.e51fe67d.jpg";